module.exports = __webpack_public_path__ + "media/images/lenders-c5b423889c3068bc33414d00c207a351.svg";